import moment from "moment";

import { DateFilter, Meeting, StatusCounts } from "../types";

export const meetingDateTime = (m: Meeting) =>
  moment(`${m.date} ${m.allDay ? "00:00" : m.from}`, "YYYY-MM-DD HH:mm");

export const matchesDate = (m: Meeting, filter: DateFilter): boolean => {
  if (filter === "all") {
    return true;
  }
  const dt = meetingDateTime(m);
  switch (filter) {
    case "upcoming":
      return dt.isSameOrAfter(moment(), "day");
    case "past":
      return dt.isBefore(moment(), "day");
    case "today":
      return dt.isSame(moment(), "day");
    case "week":
      return dt.isSame(moment(), "week");
    case "month":
      return dt.isSame(moment(), "month");
    default:
      return true;
  }
};

export const countStatuses = (list: Meeting[]): StatusCounts => {
  const counts: StatusCounts = {
    all: list.length,
    pending: 0,
    awaiting_customer: 0,
    confirmed: 0,
    completed: 0,
    cancelled: 0,
    declined: 0,
    reschedule_requested: 0,
  };
  for (const m of list) {
    counts[m.displayStatus] += 1;
  }
  return counts;
};
